module.exports = "<div class=\"well padding-v-large\">\n  <h1 class=\"margin-b-large block\">Ordine completato</h1>\n\n  <h2 class=\"margin-b-large block\">Grazie per aver effettuato il tuo ordine<br /> A breve riceverai una e-mail di conferma</h2>\n\n  <img class=\"img-responsive margin-v-large\" src=\"/Content/images/configurator/logo{{ this.config.isModeZodio ? '-zodio' : null }}.png\" alt=\"topcolor logo\" />\n  <!--{{ this.OldTotalCart }}<br> {{ this.OldTotalCart > 0 }}-->\n\n\n\n\n  <!--<div *ngIf=\"this.OldTotalCart > 0\">-->\n  <!--</div>-->\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/order-completed.component.html
// module id = 609
// module chunks = 1